import { DateUtils } from 'react-frontend-utils'

export class Community {
      
    name;                           //Name of the community   
    version;                        
     
    extendedName;                   
    logoImage;                      //base64

    enableElectronicPasses;
    enablePhysicalPasses;
    enableGenericPasses;

    bulkMail;
    bulkMailAddress;
    genericPassMailAddress;
    lastBulkMailDate;

    specialHandling;

    //Fields below are settings for Electronic Passes
    ePassNeverExpires;          //true or false
    eFontColor;
    eBackgroundColor;
    eSecondaryFields;           //array of pass field object with keys: label, dynamicDataType, and fixedText
    eAuxiliaryFields;           //array of PassField object with keys: label, dynamicDataType, and fixedText
    eBackFields;                //array of PassField object with keys: label, dynamicDataType, and fixedText
    eEnablePatronImage;         //true to enable
    eBarcode;                   //true to enable
    eBarcodeShowValue;          //true to show the value

    //Fields below are settings for PhysicalPasses
    pPrintFrontOnly;           //true to only print front of generic pass
    pOrientationIsVertical;    //true or false
    pFontColor;
    
    pEnablePatronImage;         //true to enable
    pPatronImageBorder;         //true to enable
    pBarcode;                   //true to enable
    pBarcodeShowValue;          //true to show the value

    pPrimaryField;              //single ColoredPassField object
    pFrontSecondaryFields;      //array of pass field object with keys: label, dynamicDataType, and fixedText
    pBackFields;                //array of pass field object with keys: label, dynamicDataType, and fixedText

    //Fields below are settings for GenericPasses
    gOrientationIsVertical;    //true or false
    gFontColor;                 //stored as #rrggbb in hex
    gTitleFont;
    gTitleFontSize;                 //0 = normal, 1 = larger, -1 = smaller
    gBarcode;                   //true to enable
    gBarcodeShowValue;          //true to show the value
    gColoredField;             //single GenericPassField object, this is the same as the primary field in Physical Pass
    gColoredFieldColor;
    gFrontSecondaryFields;      //array of pass field object with keys: label, dynamicDataType (always FIXED), and fixedText
    gBackFields;                //array of pass field object with keys: label, dynamicDataType (always FIXED, and fixedText

    isSelfPrintClient;         //not stored in backend, set by frontend based on group info

    constructor(json) {
        if (json) { 
            this.name = json.name;
            this.version = json.version;

            this.extendedName = json.extendedName;
            this.logoImage = json.logoImage;
            
            this.enableElectronicPasses = json.enableElectronicPasses;
            this.enablePhysicalPasses = json.enablePhysicalPasses;
            this.enableGenericPasses = json.enableGenericPasses;
            this.bulkMail = json.bulkMail;
            this.bulkMailAddress = json.bulkMailAddress;
            this.genericPassMailAddress = json.genericPassMailAddress;
            this.lastBulkMailDate = json.lastBulkMailDate;  // leave this so post back to server won't be affected 
            this.specialHandling = json.specialHandling;

            this.ePassNeverExpires = json.ePassNeverExpires;
            this.eFontColor = json.eFontColor;
            this.eBackgroundColor = json.eBackgroundColor;
            this.eEnablePatronImage = json.eEnablePatronImage;
            this.eSecondaryFields = json.eSecondaryFields;          //Limit 3
            this.eAuxiliaryFields = json.eAuxiliaryFields;          //Limit 3
            this.eBackFields = json.eBackFields;                    //Limit 4

            this.eBarcode = json.eBarcode;
            this.eBarcodeShowValue = json.eBarcodeShowValue;

            this.pPrintFrontOnly = json.pPrintFrontOnly;
            this.pOrientationIsVertical = json.pOrientationIsVertical;
            this.pTitleFont = json.pTitleFont;
            this.pTitleFontSize = json.pTitleFontSize;
            this.pFontColor = json.pFontColor;
            this.pEnablePatronImage = json.pEnablePatronImage;
            this.pPatronImageBorder = json.pPatronImageBorder;
            this.pPrimaryField = json.pPrimaryField;
            this.pSecondaryFields = json.pSecondaryFields;
            this.pBackFields = json.pBackFields;
            this.pBarcode = json.pBarcode;
            this.pBarcodeShowValue = json.pBarcodeShowValue;

            this.gOrientationIsVertical = json.gOrientationIsVertical;
            this.gFontColor = json.gFontColor;
            this.gTitleFont = json.gTitleFont;
            this.gTitleFontSize = json.gTitleFontSize;
            this.gColoredField = json.gColoredField;
            this.gColoredFieldColor = json.gColoredFieldColor;
            this.gSecondaryFields = json.gSecondaryFields;
            this.gBackFields = json.gBackFields;
            this.gBarcode = json.gBarcode;
            this.gBarcodeShowValue = json.gBarcodeShowValue;

            this.isSelfPrintClient = json.isSelfPrintClient;
        }
    }
    

    getLastBulkMailDate() {
        if (this.lastBulkMailDate)
            return DateUtils.parseJsonDate(this.lastBulkMailDate, true); //convert from UTC
        else
            return null;
    }
    
    
    
    static createNew(name) {
        
        const c = new Community();
        c.name = name;
        c.enableElectronicPasses = false;
        c.enablePhysicalPasses = false;
        c.enableGenericPasses = false;
        c.bulkMail = false;
        c.bulkMailAddress = "";
        c.genericPassMailAddress = "";
        c.lastBulkMailDate = null;
        c.specialHandling = "";
        
        c.eFontColor = '#000000';
        c.eBackgroundColor = '#ffffff';

        c.ePassNeverExpires = false;
        c.eEnablePatronImage = true;
        c.pPatronImageBorder = false;
        c.eSecondaryFields = [];
        c.eAuxiliaryFields = [];
        c.eBackFields = [];
        c.eBarcode = true;
        c.eBarcodeShowValue = false;

        c.pPrintFrontOnly = false;
        c.pOrientationIsVertical = true;
        c.pTitleFont = "Arial";
        c.pTitleFontSize = 0; //normal
        c.pFontColor = '#000000';
        c.pEnablePatronImage = true;
        c.pPrimaryField = null;
        c.pSecondaryFields = [];
        c.pBackFields = [];
        c.pBarcode = true;
        c.pBarcodeShowValue = false;

        c.gOrientationIsVertical = true;
        c.gFontColor = '#000000';
        c.gTitleFont = "Arial";
        c.gTitleFontSize = 0; //normal
        c.gColoredField = null;
        c.gColoredFieldColor = '#000000';
        c.gSecondaryFields = [];
        c.gBackFields = [];
        c.gBarcode = true;
        c.gBarcodeShowValue = false;    

        return c;
    }
    


   
}